var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dark-card"},[_vm._t("default",function(){return [_c('div',{staticClass:"inner"},[_c('div',{staticClass:"header"},[_vm._t("header")],2),_c('div',{staticClass:"body"},[_vm._t("body")],2),_c('div',{staticClass:"footer"},[_vm._t("footer")],2)])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }